import React from "react";
import EventsGrid from "./EventsGrid/EventsGrid";

const DisplayEvents = ({
  events,
  getAllEvents = () => {},
  loading = false,
}) => {
  return (
    <EventsGrid
      events={events}
      loading={loading}
      onRefresh={getAllEvents}
    />
  );
};

export default DisplayEvents;
